import { arrayGetSet, createAccessors } from 'z3k-parser/lib/accessories';
export var AnalogDut;
(function (AnalogDut) {
    AnalogDut.get = createAccessors(arrayGetSet('analog_duts'), {
        physical_input: -1,
        name: 'Аналоговый ДУТ',
        signal_normalization: 0,
        setting_register: 1,
        lower_threshold: 0,
        rol_connection_lost: [],
        no_connection_timeout: 1,
        calibration: -1,
        egts: 0,
    });
})(AnalogDut || (AnalogDut = {}));
